import { useForm, getFormProps } from '@conform-to/react'
import { useFetcher } from '@remix-run/react'
import { Icon } from '#app/components/ui/icon'
import { useOptimisticThemeMode } from '#app/hooks/use-theme'
import { type Theme } from '#app/utils/theme.server'

export function ChangeThemeForm({
  userPreference,
  id,
}: {
  userPreference?: Theme | null
  id: string
}) {
  const fetcher = useFetcher<{ result: any }>({ key: 'change-theme' })

  const [form] = useForm({
    id: `theme-switch-${id}`,
    lastResult: fetcher.data?.result,
  })

  const optimisticMode = useOptimisticThemeMode()
  const mode = optimisticMode ?? userPreference ?? 'system'
  const nextMode = mode === 'system' ? 'light' : mode === 'light' ? 'dark' : 'system'
  const modeLabel = {
    light: (
      <Icon name="sun">
        <span className="sr-only">Light</span>
      </Icon>
    ),
    dark: (
      <Icon name="moon">
        <span className="sr-only">Dark</span>
      </Icon>
    ),
    system: (
      <Icon name="laptop">
        <span className="sr-only">System</span>
      </Icon>
    ),
  }

  return (
    <fetcher.Form method="POST" action="/settings/change-theme" {...getFormProps(form)}>
      <input type="hidden" name="theme" value={nextMode} />
      <div className="flex gap-2">
        <button
          type="submit"
          className="focusable flex h-8 w-8 cursor-pointer items-center justify-center"
        >
          {modeLabel[mode]}
        </button>
      </div>
    </fetcher.Form>
  )
}
